import React from 'react';

import { Icon } from '../icons';

export const VideoUploadIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 42 21" fill={color} style={style}>
      <g>
        <path d="M.417 9.497h3.75v-3.75c0-.23.186-.417.416-.417h.834c.23 0 .416.187.416.417v3.75h3.75c.23 0 .417.187.417.417v.833c0 .23-.186.417-.417.417h-3.75v3.75c0 .23-.186.416-.416.416h-.834a.416.416 0 0 1-.416-.416v-3.75H.417A.417.417 0 0 1 0 10.747v-.833c0-.23.186-.417.417-.417Z" />
        <path
          fillRule="evenodd"
          d="M42 2.864C42 1.282 40.746 0 39.2 0H16.8C15.254 0 14 1.282 14 2.864v15.272C14 19.718 15.254 21 16.8 21h22.4c1.546 0 2.8-1.282 2.8-2.864V2.864Zm-24.85 0h21.7c.193 0 .35.16.35.357v14.557a.354.354 0 0 1-.35.358h-21.7a.354.354 0 0 1-.35-.358V3.221c0-.197.157-.358.35-.358Z"
          clipRule="evenodd"
        />
        <path d="M26.177 6.228a1 1 0 0 0-1.51.86v7.157a1 1 0 0 0 1.51.86l6.038-3.578a1 1 0 0 0 0-1.72l-6.039-3.579Z" />
      </g>
    </svg>
  );
};
